import { Box } from '@mui/material'
import CoverageChart from './ChartSection/CoverageChart'
import CoverageScorecard from './ChartSection/CoverageScorecard'
import { SvgCaret } from './components/DropDown'
import InformationSection from './InformationSection'
import { H2 } from './MethodologyAndMetrica.styled'
import { Fragment, useEffect, useState } from 'react'
import { DATA_FILE_PATH, DATA_FILE_NAME, VARIABLE_LIST } from 'constant'
import Papa from 'papaparse'
import { useDataWithMetric } from 'utils'

const MethodologyAndMetrics = () => {
  const { data, loading, error } = useDataWithMetric(`${DATA_FILE_PATH}${DATA_FILE_NAME}.csv`)
  const {
    data: variableData,
    loading: variableLoading,
    error: variableError,
  } = useDataWithMetric(`${DATA_FILE_PATH}${VARIABLE_LIST}.csv`)
  const [rawCountryData, setRawCountryData] = useState<any[] | null>(null)
  const [rawVariableData, setRawVariableData] = useState<any[] | null>(null)

  useEffect(() => {
    if (data && !loading && !error) {
      setRawCountryData(data)
    }
  }, [data, loading, error])

  useEffect(() => {
    if (variableData && !variableLoading && !variableError) {
      setRawVariableData(variableData)
    }
  }, [variableData, variableLoading, variableError])
  const [isOpen, setIsOpen] = useState(false)

  // const fetchCsvData = async (path: string) => {
  //   const response = await fetch(path)
  //   const reader = response.body?.getReader()
  //   const result = await reader?.read()
  //   const decoder = new TextDecoder('utf-8')
  //   const csv = decoder.decode(result?.value)
  //   const results = Papa.parse(csv, { header: true })
  //   return results.data
  // }

  // useEffect(() => {
  //   if (isOpen && !rawCountryData) {
  //     fetchCsvData(`${DATA_FILE_PATH}${DATA_FILE_NAME}.csv`).then((data) => {
  //       setRawCountryData(data)
  //     })
  //   }
  // }, [rawCountryData, isOpen])

  // useEffect(() => {
  //   if (isOpen && !rawVariableData) {
  //     fetchCsvData(`${DATA_FILE_PATH}${VARIABLE_LIST}.csv`).then((data) => {
  //       setRawVariableData(data)
  //     })
  //   }
  // }, [rawVariableData, isOpen])

  return (
    <Box width={'100%'} padding={'0 8px'}>
      <Box width={'100%'} display='flex' alignItems={'center'} flexDirection={'column'} justifyContent={'center'}>
        <Box width={'100%'} maxWidth={1550}>
          <Box
            width={'100%'}
            mb={'40px'}
            display='flex'
            alignItems={'center'}
            sx={{ cursor: 'pointer' }}
            onClick={() => setIsOpen(!isOpen)}
          >
            <H2 style={{ display: 'inline', marginBottom: 0, fontWeight: '400' }} className='methodologyHeading'>
              Methodology and Metrics
            </H2>
            <SvgCaret open={isOpen} />
          </Box>
          {isOpen ? <InformationSection /> : null}
        </Box>
      </Box>
      {isOpen ? (
        <Fragment>
          <Box height={'80px'} />
          <CoverageScorecard rawCountryData={rawCountryData} rawVariableData={rawVariableData} />
          <Box height={'60px'} />
          <Box width={'100%'} display='flex' alignItems={'center'} flexDirection={'column'} justifyContent={'center'}>
            <Box width={'100%'} maxWidth={1550} alignSelf={'center'} marginBottom={5}>
              <CoverageChart rawCountryData={rawCountryData} rawVariableData={rawVariableData} />
            </Box>
          </Box>
        </Fragment>
      ) : null}
    </Box>
  )
}

export default MethodologyAndMetrics
